import { SimplifiedBranchCashReconciliationService } from "../../services";
import { createCRUDThunksLegacy } from "../../shared/helpers";
import {
  ISimplifiedBranchCashReconciliationRequest,
  ISimplifiedBranchCashReconciliationResponse,
} from "../../shared/types";

const service = new SimplifiedBranchCashReconciliationService();
export const simplifiedBranchCashReconciliationThunks = createCRUDThunksLegacy<
  ISimplifiedBranchCashReconciliationResponse,
  ISimplifiedBranchCashReconciliationRequest
>({
  service,
  resourceName: "simplified-branch-cash-reconciliation",
});
